import { api } from "@/api";
import { AddSportNewParams, SportDto } from "@/types/ApiResponses/Sport";

export const addSportNew = async (
  params: AddSportNewParams
): Promise<SportDto> => {
  const res = await api.client.post(`/sports-new`, params);
  return res.data;
};
